/* tslint:disable */
/* eslint-disable */
/**
 * Melco Tracking APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    TrackingMelcoModelsError,
    TrackingMelcoModelsErrorFromJSON,
    TrackingMelcoModelsErrorToJSON,
    TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityAppListItem,
    TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityAppListItemFromJSON,
    TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityAppListItemToJSON,
    TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItem,
    TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItemFromJSON,
    TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItemToJSON,
} from '../models';

export interface StatusAnalyticsApiStatusServiceGetDailyListRequest {
    appList?: string;
}

export interface StatusAnalyticsApiStatusServiceGetHourlyListRequest {
    appList?: string;
}

export interface StatusAnalyticsApiStatusServiceGetListRequest {
    includeInternalApps?: boolean;
}

export interface StatusAnalyticsApiStatusServiceGetMonthlyListRequest {
    appList?: string;
}

/**
 * 
 */
export class StatusAnalyticsApi extends runtime.BaseAPI {

    /**
     */
    async statusServiceGetDailyListRaw(requestParameters: StatusAnalyticsApiStatusServiceGetDailyListRequest): Promise<runtime.ApiResponse<TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.appList !== undefined) {
            queryParameters['app_list'] = requestParameters.appList;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/analytics/status/daily`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItemFromJSON(jsonValue));
    }

    /**
     */
    async statusServiceGetDailyList(requestParameters: StatusAnalyticsApiStatusServiceGetDailyListRequest): Promise<TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItem> {
        const response = await this.statusServiceGetDailyListRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async statusServiceGetHourlyListRaw(requestParameters: StatusAnalyticsApiStatusServiceGetHourlyListRequest): Promise<runtime.ApiResponse<TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.appList !== undefined) {
            queryParameters['app_list'] = requestParameters.appList;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/analytics/status/hourly`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItemFromJSON(jsonValue));
    }

    /**
     */
    async statusServiceGetHourlyList(requestParameters: StatusAnalyticsApiStatusServiceGetHourlyListRequest): Promise<TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItem> {
        const response = await this.statusServiceGetHourlyListRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async statusServiceGetListRaw(requestParameters: StatusAnalyticsApiStatusServiceGetListRequest): Promise<runtime.ApiResponse<TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityAppListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.includeInternalApps !== undefined) {
            queryParameters['include_internal_apps'] = requestParameters.includeInternalApps;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/analytics/status/apps`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityAppListItemFromJSON(jsonValue));
    }

    /**
     */
    async statusServiceGetList(requestParameters: StatusAnalyticsApiStatusServiceGetListRequest): Promise<TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityAppListItem> {
        const response = await this.statusServiceGetListRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async statusServiceGetMonthlyListRaw(requestParameters: StatusAnalyticsApiStatusServiceGetMonthlyListRequest): Promise<runtime.ApiResponse<TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.appList !== undefined) {
            queryParameters['app_list'] = requestParameters.appList;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/analytics/status/monthly`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItemFromJSON(jsonValue));
    }

    /**
     */
    async statusServiceGetMonthlyList(requestParameters: StatusAnalyticsApiStatusServiceGetMonthlyListRequest): Promise<TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItem> {
        const response = await this.statusServiceGetMonthlyListRaw(requestParameters);
        return await response.value();
    }

}
